module.exports = __webpack_public_path__ + "img/main_sm - copie.0a04889a.jpeg";